{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "HEADER": "Shopify",
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Atcelt",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integrācijas",
    "DESCRIPTION": "Chatwoot integrējas ar vairākiem rīkiem un pakalpojumiem, lai uzlabotu jūsu komandas efektivitāti. Izpētiet tālāk esošo sarakstu, lai konfigurētu savas iecienītākās lietotnes.",
    "LEARN_MORE": "Uzzināt vairāk par integrācijām",
    "LOADING": "Integrāciju iegūšana",
    "SEARCH_PLACEHOLDER": "Search integrations...",
    "NO_RESULTS": "No integrations found matching your search",
    "CAPTAIN": {
      "DISABLED": "Captain jūsu kontā nav iespējots.",
      "CLICK_HERE_TO_CONFIGURE": "Noklikšķiniet šeit, lai konfigurētu",
      "LOADING_CONSOLE": "Notiek Captain konsoles ielāde...",
      "FAILED_TO_LOAD_CONSOLE": "Neizdevās ielādēt Captain konsoli. Lūdzu, mēģiniet vēlreiz."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Abonētie Notikumi",
      "LEARN_MORE": "Uzzināt vairāk par webhooks",
      "SECRET": {
        "LABEL": "Secret",
        "COPY": "Copy secret to clipboard",
        "COPY_SUCCESS": "Secret copied to clipboard",
        "TOGGLE": "Toggle secret visibility",
        "CREATED_DESC": "Your webhook has been created. Use the secret below to verify webhook signatures. Please copy it now — you can also find it later in the webhook edit form.",
        "DONE": "Done"
      },
      "COUNT": "{n} webhook | {n} webhooks",
      "SEARCH_PLACEHOLDER": "Search webhooks...",
      "NO_RESULTS": "No webhooks found matching your search",
      "FORM": {
        "CANCEL": "Atcelt",
        "DESC": "Webhook notikumi sniedz Jums reāllaika informāciju par to, kas notiek jūsu Chatwoot kontā. Lūdzu, ievadiet derīgu URL, lai nokonfigurētu atzvanīšanu.",
        "SUBSCRIPTIONS": {
          "LABEL": "Notikumi",
          "EVENTS": {
            "CONVERSATION_CREATED": "Saruna izveidota",
            "CONVERSATION_STATUS_CHANGED": "Sarunas Statuss Mainīts",
            "CONVERSATION_UPDATED": "Saruna Atjaunināta",
            "MESSAGE_CREATED": "Ziņojums izveidots",
            "MESSAGE_UPDATED": "Ziņojums atjaunināts",
            "WEBWIDGET_TRIGGERED": "Lietotājs atvēra tiešsaistes tērzēšanas logrīku",
            "CONTACT_CREATED": "Kontaktpersona izveidota",
            "CONTACT_UPDATED": "Kontaktpersona atjaunināta",
            "CONVERSATION_TYPING_ON": "Conversation Typing On",
            "CONVERSATION_TYPING_OFF": "Conversation Typing Off",
            "INBOX_UPDATED": "Inbox updated"
          }
        },
        "NAME": {
          "LABEL": "Webhook Name",
          "PLACEHOLDER": "Enter the name of the webhook"
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Piemēram: {webhookExampleURL}",
          "ERROR": "Lūdzu, ievadiet derīgu URL"
        },
        "EDIT_SUBMIT": "Atjaunināt webhook",
        "ADD_SUBMIT": "Izveidot webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Konfigurēt",
      "HEADER": "Webhook iestatījumi",
      "HEADER_BTN_TXT": "Pievienot jaunu webhook",
      "LOADING": "Notiek pievienoto webhook iegūšana",
      "SEARCH_404": "Šim vaicājumam nav atbilstošu vienumu",
      "SIDEBAR_TXT": "<p><b>Webhook</b> </p> <p>Webhook ir HTTP atzvani, kurus var definēt katram kontam. Tos aktivizē tādi notikumi kā ziņojumu izveide pakalpojumā Chatwoot. Šim kontam varat izveidot vairāk nekā vienu webhook. <br /><br /> Lai izveidotu <b>webhook</b>, noklikšķiniet uz <b>Pievienot jaunu webhook</b> pogas. Jūs varat arī noņemt jebkuru esošo webhook, noklikšķinot uz pogas Dzēst.</p>",
      "LIST": {
        "404": "Šim kontam nav nokonfigurēts neviens webhook.",
        "TITLE": "Pārvaldīt webhook",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook galapunkts",
          "ACTIONS": "Darbības"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Rediģēt",
        "TITLE": "Rediģēt webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook konfigurācija ir veiksmīgi atjaunināta",
          "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
        }
      },
      "ADD": {
        "CANCEL": "Atcelt",
        "TITLE": "Pievienot jaunu webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook konfigurācija ir veiksmīgi pievienota",
          "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Dzēst",
        "API": {
          "SUCCESS_MESSAGE": "Webhook ir veiksmīgi izdzēsts",
          "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
        },
        "CONFIRM": {
          "TITLE": "Apstiprināt Dzēšanu",
          "MESSAGE": "Vai tiešām vēlaties izdzēst webhook? ({webhookURL})",
          "YES": "Jā, Dzēst ",
          "NO": "Nē, Paturēt"
        }
      }
    },
    "SLACK": {
      "HEADER": "Slack",
      "DELETE": "Dzēst",
      "DELETE_CONFIRMATION": {
        "TITLE": "Dzēst integrāciju",
        "MESSAGE": "Vai tiešām vēlaties dzēst integrāciju? To darot, tiks zaudēta piekļuve sarunām Jūsu Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "Kā izmantot Slack integrāciju?",
        "BODY": "Izmantojot šo integrāciju, visas jūsu ienākošās sarunas tiks sinhronizētas ar kanālu ***{selectedChannelName}*** jūsu Slack darbvietā. Jūs varat pārvaldīt visas savas klientu sarunas tieši kanālā un nekad nepalaist garām nevienu ziņojumu.\n\nŠādas ir galvenās integrācijas īpašības:\n\n**Atbldēt uz sarunām no Slack:** Lai atbildētu uz sarunu ***{selectedChannelName}*** Slack kanālā, uzrakstiet savu ziņojumu un nosūtiet to kā pavedienu. Šādi tiks izveidota atbilde klientam, izmantojot Chatwoot.\n\n**Izveidot privātas piezīmes:** ja vēlaties izveidot privātas piezīmes, nevis atbildes, sāciet ziņojumu ar ***`note:`***. Tas nodrošina, ka jūsu ziņojums ir privāts un nebūs redzams klientam.\n\n**Saistīt aģenta profilu:** ja personai, kas atbildēja Slack, ir Chatwoot aģenta profils ar to pašu e-pasta adresi, atbildes tiks automātiski saistītas ar šo aģenta profilu. Tas nozīmē, ka varat viegli izsekot kurš ko teica un kad. No otras puses, ja atbildētājam nav saistīta aģenta profila, atbildes klientam tiks rādītas no robotprogrammatūras profila.",
        "SELECTED": "izvēlēts"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Izvēlēties kanālu",
        "UPDATE": "Atjaunināt",
        "BUTTON_TEXT": "Pievienot kanālu",
        "DESCRIPTION": "Jūsu Slack workspace tagad ir saistīta ar Chatwoot, taču integrācija pašlaik ir neaktīva. Lai aktivizētu integrāciju un savienotu kanālu ar Chatwoot, lūdzu, noklikšķiniet uz tālāk esošās pogas.\n\n**Piezīme:** Ja mēģinat izveidot savienojumu ar privātu kanālu, pirms turpināt šo darbību, pievienojiet lietotni Chatwoot Slack kanālam.",
        "ATTENTION_REQUIRED": "Nepieciešama uzmanība",
        "EXPIRED": "Jūsu Slack integrācijas derīguma termiņš ir beidzies. Lai turpinātu saņemt ziņojumus pakalpojumā Slack, lūdzu, izdzēsiet integrāciju un vēlreiz pievienojiet savu workspace."
      },
      "UPDATE_ERROR": "Atjauninot integrāciju radās kļūda. Lūdzu, mēģiniet vēlreiz",
      "UPDATE_SUCCESS": "Kanāls ir veiksmīgi pievienots",
      "FAILED_TO_FETCH_CHANNELS": "Ienesot kanālus no Slack radās kļūda. Lūdzu, mēģiniet vēlreiz"
    },
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Noklikšķiniet šeit, lai pievienotos",
      "LEAVE_THE_ROOM": "Iziet no istabas",
      "START_VIDEO_CALL_HELP_TEXT": "Sākt jaunu videozvanu ar klientu",
      "JOIN_ERROR": "Pievienojoties zvanam, radās kļūda. Lūdzu, mēģiniet vēlreiz",
      "CREATE_ERROR": "Veidojot sapulces saiti, radās kļūda. Lūdzu, mēģiniet vēlreiz"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI Palīgs",
      "WITH_AI": " {option} ar AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Atbildes Ieteikums",
        "SUMMARIZE": "Apkopot",
        "REPHRASE": "Uzlabot Rakstību",
        "FIX_SPELLING_GRAMMAR": "Izlabot Pareizrakstību un Gramatiku",
        "SHORTEN": "Saīsināt",
        "EXPAND": "Izvērst",
        "MAKE_FRIENDLY": "Mainīt ziņojuma toni uz draudzīgu",
        "MAKE_FORMAL": "Izmantot formālu toni",
        "SIMPLIFY": "Vienkāršot",
        "CONFIDENT": "Use confident tone",
        "PROFESSIONAL": "Use professional tone",
        "CASUAL": "Use casual tone",
        "STRAIGHTFORWARD": "Use straightforward tone"
      },
      "REPLY_OPTIONS": {
        "IMPROVE_REPLY": "Improve reply",
        "IMPROVE_REPLY_SELECTION": "Improve the selection",
        "CHANGE_TONE": {
          "TITLE": "Change tone",
          "OPTIONS": {
            "PROFESSIONAL": "Profesionāls",
            "CASUAL": "Casual",
            "STRAIGHTFORWARD": "Straightforward",
            "CONFIDENT": "Confident",
            "FRIENDLY": "Draudzīgs"
          }
        },
        "GRAMMAR": "Fix grammar & spelling",
        "SUGGESTION": "Suggest a reply",
        "SUMMARIZE": "Summarize the conversation",
        "ASK_COPILOT": "Ask Copilot"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Melnraksta saturs",
        "GENERATED_TITLE": "Ģenerētais saturs",
        "AI_WRITING": "AI raksta",
        "BUTTONS": {
          "APPLY": "Izmantot šo ieteikumu",
          "CANCEL": "Atcelt"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrēt ar OpenAI",
        "DESC": "Ievietot uzlabotās AI funkcijas savā informācijas panelī, izmantojot OpenAI GPT modeļus. Lai sāktu, ievadiet sava OpenAI konta API atslēgu.",
        "KEY_PLACEHOLDER": "Ievadiet savu OpenAI API atslēgu",
        "BUTTONS": {
          "NEED_HELP": "Nepieciešama palīdzība?",
          "DISMISS": "Atcelt",
          "FINISH": "Pabeigt Iestatīšanu"
        },
        "DISMISS_MESSAGE": "OpenAI integrāciju varat iestatīt vēlāk, kad vien vēlaties.",
        "SUCCESS_MESSAGE": "OpenAI integrācija iestatīta veiksmīgi"
      },
      "TITLE": "Uzlabot ar AI",
      "SUMMARY_TITLE": "Kopsavilkums ar AI",
      "REPLY_TITLE": "Atbildes rekomendācija ar AI",
      "SUBTITLE": "Izmantojot AI, tiks ģenerēta uzlabota atbilde, pamatojoties uz jūsu pašreizējo melnrakstu.",
      "TONE": {
        "TITLE": "Tonis",
        "OPTIONS": {
          "PROFESSIONAL": "Profesionāls",
          "FRIENDLY": "Draudzīgs"
        }
      },
      "BUTTONS": {
        "GENERATE": "Ģenerēt",
        "GENERATING": "Notiek ģenerēšana...",
        "CANCEL": "Atcelt"
      },
      "GENERATE_ERROR": "Apstrādājot saturu radās kļūda. Lūdzu, pārbaudiet savu OpenAI API atslēgu un mēģiniet vēlreiz"
    },
    "DELETE": {
      "BUTTON_TEXT": "Dzēst",
      "API": {
        "SUCCESS_MESSAGE": "Integrācija ir veiksmīgi izdzēsta"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Savienot"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Informācijas paneļa lietotnes",
      "HEADER_BTN_TXT": "Pievienot jaunu informācijas paneļa lietotni",
      "SIDEBAR_TXT": "<p><b>Informācijas Paneļa Lietotnes</b></p><p>Informācijas paneļa lietotnes ļauj organizācijām iegult lietojumprogrammu Chatwoot informācijas panelī, lai nodrošinātu kontekstu klientu atbalsta aģentiem. Šī funkcija ļauj Jums izveidot lietojumprogrammu neatkarīgi un iegult to informācijas panelī, lai sniegtu informāciju par lietotāju, viņu pasūtījumiem vai viņu iepriekšējo maksājumu vēsturi.</p><p>Kad iegulsiet lietojumprogrammu, izmantojot Chatwoot informācijas paneli, Jūsu lietojumprogramma iegūs sarunas un kontaktpersonas kontekstu kā loga notikumu. Ieviesiet savā lapā ziņojuma notikuma uztvērēju, lai saņemtu kontekstu.</p><p>Lai pievienotu jaunu informācijas paneļa lietotni, noklikšķiniet uz pogas 'Pievienot jaunu informācijas paneļa lietotni'.</p>",
      "DESCRIPTION": "Informācijas paneļa lietotnes ļauj organizācijām iegult lietojumprogrammu informācijas panelī, lai nodrošinātu kontekstu klientu atbalsta aģentiem. Šī funkcija ļauj Jums neatkarīgi izveidot lietojumprogrammu un iegult to, lai sniegtu informāciju par lietotāju, viņu pasūtījumiem vai iepriekšējo maksājumu vēsturi.",
      "LEARN_MORE": "Uzzināt vairāk par Informācijas paneļa Lietotnēm",
      "COUNT": "{n} dashboard app | {n} dashboard apps",
      "SEARCH_PLACEHOLDER": "Search dashboard apps...",
      "NO_RESULTS": "No dashboard apps found matching your search",
      "LIST": {
        "404": "Šajā kontā vēl nav nokonfigurēta neviena informācijas paneļa lietotne",
        "LOADING": "Notiek informācijas paneļa lietotņu iegūšana...",
        "TABLE_HEADER": {
          "NAME": "Nosaukums",
          "ENDPOINT": "Endpoint",
          "ACTIONS": "Darbības"
        },
        "EDIT_TOOLTIP": "Rediģēt lietotni",
        "DELETE_TOOLTIP": "Dzēst lietotni"
      },
      "FORM": {
        "TITLE_LABEL": "Nosaukums",
        "TITLE_PLACEHOLDER": "Ievadiet informācijas paneļa lietotnes nosaukumu",
        "TITLE_ERROR": "Informācijas paneļa lietotnei ir jānorāda nosaukums",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Ievadiet endpoint URL, kurā tiek mitināta jūsu lietotne",
        "URL_ERROR": "Nepieciešams derīgs URL"
      },
      "CREATE": {
        "HEADER": "Pievienot jaunu informācijas paneļa lietotni",
        "FORM_SUBMIT": "Iesniegt",
        "FORM_CANCEL": "Atcelt",
        "API_SUCCESS": "Informācijas paneļa lietotne ir veiksmīgi nokonfigurēta",
        "API_ERROR": "Mēs nevarējām izveidot lietotni. Lūdzu, vēlāk pamēģiniet vēlreiz"
      },
      "UPDATE": {
        "HEADER": "Rediģēt informācijas paneļa lietotni",
        "FORM_SUBMIT": "Atjaunināt",
        "FORM_CANCEL": "Atcelt",
        "API_SUCCESS": "Informācijas paneļa lietotne ir veiksmīgi atjaunināta",
        "API_ERROR": "Mēs nevarējām atjaunināt lietotni. Lūdzu, vēlāk pamēģiniet vēlreiz"
      },
      "DELETE": {
        "CONFIRM_YES": "Jā, dzēst",
        "CONFIRM_NO": "Nē, paturēt",
        "TITLE": "Apstipriniet dzēšanu",
        "MESSAGE": "Vai tiešām vēlaties izdzēst lietotni - {appName}?",
        "API_SUCCESS": "Informācijas paneļa lietotne ir veiksmīgi izdzēsta",
        "API_ERROR": "Mēs nevarējām izdzēst lietotni. Lūdzu, vēlāk pamēģiniet vēlreiz"
      }
    },
    "LINEAR": {
      "HEADER": "Lineārs",
      "ADD_OR_LINK_BUTTON": "Izveidot/Saistīt lineāru problēmu",
      "LOADING": "Notiek lineāru problēmu iegūšana...",
      "LOADING_ERROR": "Lineāru problēmu iegūšanas laikā radās kļūda. Lūdzu, mēģiniet vēlreiz",
      "CREATE": "Izveidot",
      "LINK": {
        "SEARCH": "Meklēt problēmas",
        "SELECT": "Izvēlieties problēmu",
        "TITLE": "Saite",
        "EMPTY_LIST": "Netika atrasta neviena lineāra problēma",
        "LOADING": "Notiek ielāde",
        "ERROR": "Lineāru problēmu iegūšanas laikā radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "LINK_SUCCESS": "Problēma ir veiksmīgi sasaistīta",
        "LINK_ERROR": "Sasaistot problēmu radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "LINK_TITLE": "Saruna (#{conversationId}) ar {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Izveidot/saistīt lineāru problēmu",
        "DESCRIPTION": "Izveidot lineārus jautājumus no sarunām, vai saistīt esošos netraucētai izsekošanai.",
        "FORM": {
          "TITLE": {
            "LABEL": "Nosaukums",
            "PLACEHOLDER": "Ievadiet virsrakstu",
            "REQUIRED_ERROR": "Nepieciešams nosaukums"
          },
          "DESCRIPTION": {
            "LABEL": "Apraksts",
            "PLACEHOLDER": "Ievadiet aprakstu"
          },
          "TEAM": {
            "LABEL": "Komanda",
            "PLACEHOLDER": "Izvēlieties komandu",
            "SEARCH": "Meklēt komandu",
            "REQUIRED_ERROR": "Nepieciešama komanda"
          },
          "ASSIGNEE": {
            "LABEL": "Uzdevuma saņēmējs",
            "PLACEHOLDER": "Izvēlēties pilnvaroto",
            "SEARCH": "Meklēt pilnvaroto"
          },
          "PRIORITY": {
            "LABEL": "Prioritāte",
            "PLACEHOLDER": "Izvēlieties prioritāti",
            "SEARCH": "Meklēt prioritāti"
          },
          "LABEL": {
            "LABEL": "Etiķete",
            "PLACEHOLDER": "Izvēlēties etiķeti",
            "SEARCH": "Meklēt etiķeti"
          },
          "STATUS": {
            "LABEL": "Statuss",
            "PLACEHOLDER": "Izvēlēties statusu",
            "SEARCH": "Meklēt statusu"
          },
          "PROJECT": {
            "LABEL": "Projekts",
            "PLACEHOLDER": "Izvēlēties projektu",
            "SEARCH": "Meklēt projektu"
          }
        },
        "CREATE": "Izveidot",
        "CANCEL": "Atcelt",
        "CREATE_SUCCESS": "Problēma ir veiksmīgi izveidota",
        "CREATE_ERROR": "Veidojot problēmu radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "LOADING_TEAM_ERROR": "Ienesot komandas radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "LOADING_TEAM_ENTITIES_ERROR": "Ienesot komandas entītijas radās kļūda. Lūdzu, mēģiniet vēlreiz"
      },
      "ISSUE": {
        "STATUS": "Statuss",
        "PRIORITY": "Prioritāte",
        "ASSIGNEE": "Uzdevuma saņēmējs",
        "LABELS": "Etiķetes",
        "CREATED_AT": "Izveidots {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Atsaistīt",
        "SUCCESS": "Problēma ir veiksmīgi atsaistīta",
        "ERROR": "Atsaistot jautājumu radās kļūda. Lūdzu, mēģiniet vēlreiz"
      },
      "NO_LINKED_ISSUES": "No linked issues found",
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties dzēst integrāciju?",
        "MESSAGE": "Vai tiešām vēlaties dzēst integrāciju?",
        "CONFIRM": "Jā, dzēst",
        "CANCEL": "Atcelt"
      },
      "CTA": {
        "TITLE": "Connect to Linear",
        "AGENT_DESCRIPTION": "Linear workspace is not connected. Request your administrator to connect a workspace to use this integration.",
        "DESCRIPTION": "Linear workspace is not connected. Click the button below to connect your workspace to use this integration.",
        "BUTTON_TEXT": "Connect Linear workspace"
      }
    },
    "NOTION": {
      "HEADER": "Notion",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the Notion integration?",
        "MESSAGE": "Deleting this integration will remove access to your Notion workspace and stop all related functionality.",
        "CONFIRM": "Jā, dzēst",
        "CANCEL": "Atcelt"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Kapteinis",
    "HEADER_KNOW_MORE": "Uzzināt vairāk",
    "ASSISTANT_SWITCHER": {
      "ASSISTANTS": "Asistenti",
      "SWITCH_ASSISTANT": "Pārslēgties starp palīgiem",
      "NEW_ASSISTANT": "Izveidot palīgu",
      "EMPTY_LIST": "Palīgu nav atrasts, lūdzu, izveidojiet kādu, lai sāktu darbu"
    },
    "COPILOT": {
      "TITLE": "Kopilots",
      "TRY_THESE_PROMPTS": "Pamēģiniet",
      "PANEL_TITLE": "Sāciet darbu ar Copilot",
      "KICK_OFF_MESSAGE": "Vai nepieciešams ātrs kopsavilkums, pārbaudīt iepriekšējās sarunas vai sagatavot labāku atbildi? Copilot ir šeit, lai paātrinātu lietas.",
      "SEND_MESSAGE": "Sūtīt ziņojumu...",
      "EMPTY_MESSAGE": "Radās kļūda, ģenerējot atbildi. Lūdzu, mēģiniet vēlreiz.",
      "LOADER": "Kapteinis domā",
      "YOU": "Jūs",
      "USE": "Izmantot šo",
      "RESET": "Atiestatīt",
      "SHOW_STEPS": "Rādīt soļus",
      "SELECT_ASSISTANT": "Izvēlēties Asistentu",
      "PROMPTS": {
        "SUMMARIZE": {
          "LABEL": "Apkopot šo sarunu",
          "CONTENT": "Apkopojiet galvenos punktus, kas apspriesti starp klientu un atbalsta aģentu, tostarp klienta bažas, jautājumus un risinājumus vai atbildes, ko sniedzis atbalsta aģents"
        },
        "SUGGEST": {
          "LABEL": "Ieteikt atbildi",
          "CONTENT": "Analizējiet klienta pieprasījumu un sagatavojiet atbildi, kas efektīvi risina viņu bažas vai jautājumus. Pārliecinieties, ka atbilde ir skaidra, kodolīga un sniedz noderīgu informāciju."
        },
        "RATE": {
          "LABEL": "Novērtēt šo sarunu",
          "CONTENT": "Pārskatiet sarunu, lai redzētu, cik labi tā atbilst klienta vajadzībām. Sniedziet vērtējumu no 5, balstoties uz toni, skaidrību un efektivitāti."
        },
        "HIGH_PRIORITY": {
          "LABEL": "Augstas prioritātes sarunas",
          "CONTENT": "Dodiet man kopsavilkumu par visām augstas prioritātes atvērtajām sarunām. Iekļaujiet sarunas ID, klienta vārdu (ja pieejams), pēdējā ziņojuma saturu un piešķirto aģentu. Ja nepieciešams, grupējiet pēc statusa."
        },
        "LIST_CONTACTS": {
          "LABEL": "Kontaktpersonu saraksts",
          "CONTENT": "Parādiet man top 10 kontaktu sarakstu. Iekļaujiet vārdu, e-pastu vai tālruņa numuru (ja pieejams), pēdējās redzamības laiku, tagus (ja kādi ir)."
        }
      }
    },
    "PLAYGROUND": {
      "USER": "Jūs",
      "ASSISTANT": "Asistents",
      "MESSAGE_PLACEHOLDER": "Rakstiet savu ziņojumu...",
      "HEADER": "Izmēģinājuma laukums",
      "DESCRIPTION": "Izmantojiet šo izmēģinājuma laukumu, lai sūtītu ziņojumus savam palīgam un pārbaudītu, vai tas atbild precīzi, ātri un ar gaidīto toni.",
      "CREDIT_NOTE": "Šeit nosūtītie ziņojumi tiks ieskaitīti jūsu Captain kredītos."
    },
    "PAYWALL": {
      "TITLE": "Modernizējiet abonementu, lai izmantotu Captain AI",
      "AVAILABLE_ON": "Captain nav pieejams bezmaksas abonementā.",
      "UPGRADE_PROMPT": "Modernizējiet savu abonementu, lai iegūtu piekļuvi viruālajiem asistentiem un copilot.",
      "UPGRADE_NOW": "Pāriet uz maksas versiju tagad",
      "CANCEL_ANYTIME": "Jūs varat jebkurā laikā mainīt vai atcelt savu versiju"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI ir pieejams tikai Enterprise plānos.",
      "UPGRADE_PROMPT": "Modernizējiet savu abonementu, lai iegūtu piekļuvi viruālajiem asistentiem un copilot.",
      "ASK_ADMIN": "Lai pārietu uz maksas versiju, lūdzu sazinieties ar savu administratoru."
    },
    "BANNER": {
      "RESPONSES": "Jūs esat izmantojis vairāk kā 80% no sava atbilžu ierobežojuma. Lai turpinātu izmantot Captain AI, lūdzu, atjauniniet abonementu.",
      "DOCUMENTS": "Sasniegts dokumentu limits. Atjauniniet abonementu, lai turpinātu izmantot Captain AI."
    },
    "FORM": {
      "CANCEL": "Atcelt",
      "CREATE": "Izveidot",
      "EDIT": "Atjaunināt"
    },
    "ASSISTANTS": {
      "HEADER": "Asistenti",
      "NO_ASSISTANTS_AVAILABLE": "There are no assistants available in your account.",
      "ADD_NEW": "Izveidot jaunu asistentu",
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties izdzēst asistentu?",
        "DESCRIPTION": "Šī darbība ir pastāvīga. Dzēšot šo asistentu, tas tiks noņemts no visām pievienotajām iesūtnēm un neatgriezeniski dzēstas visas ģenerētās zināšanas.",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Asistents ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Dzēšot asistentu radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM_DESCRIPTION": "Aizpildiet anketu, lai nosauktu savu asistentu, norādītu tā mērķi un produktu, ko tas atbalstīs.",
      "CREATE": {
        "TITLE": "Izveidot asistentu",
        "SUCCESS_MESSAGE": "Asistents ir veiksmīgi izveidots",
        "ERROR_MESSAGE": "Veidojot asistentu radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM": {
        "UPDATE": "Atjaunināt",
        "SECTIONS": {
          "BASIC_INFO": "Basic Information",
          "SYSTEM_MESSAGES": "System Messages",
          "INSTRUCTIONS": "Instructions",
          "FEATURES": "Īpašības",
          "TOOLS": "Tools "
        },
        "NAME": {
          "LABEL": "Nosaukums",
          "PLACEHOLDER": "Enter assistant name",
          "ERROR": "The name is required"
        },
        "TEMPERATURE": {
          "LABEL": "Response Temperature",
          "DESCRIPTION": "Adjust how creative or restrictive the assistant's responses should be. Lower values produce more focused and deterministic responses, while higher values allow for more creative and varied outputs."
        },
        "DESCRIPTION": {
          "LABEL": "Apraksts",
          "PLACEHOLDER": "Enter assistant description",
          "ERROR": "The description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Produkta Nosaukums",
          "PLACEHOLDER": "Enter product name",
          "ERROR": "Nepieciešams produkta nosaukums"
        },
        "WELCOME_MESSAGE": {
          "LABEL": "Welcome Message",
          "PLACEHOLDER": "Enter welcome message"
        },
        "HANDOFF_MESSAGE": {
          "LABEL": "Handoff Message",
          "PLACEHOLDER": "Enter handoff message"
        },
        "RESOLUTION_MESSAGE": {
          "LABEL": "Resolution Message",
          "PLACEHOLDER": "Enter resolution message"
        },
        "INSTRUCTIONS": {
          "LABEL": "Instructions",
          "PLACEHOLDER": "Enter instructions for the assistant"
        },
        "FEATURES": {
          "TITLE": "Īpašības",
          "ALLOW_CONVERSATION_FAQS": "Ģenerēt bieži uzdotos jautājumus no atrisinātajām sarunām",
          "ALLOW_MEMORIES": "Pārtvert galvenās nianses kā atmiņas no klientu mijiedarbībām.",
          "ALLOW_CITATIONS": "Include source citations in responses",
          "ALLOW_CONTACT_ATTRIBUTES": "Allow access to contact information"
        }
      },
      "EDIT": {
        "TITLE": "Atjaunināt asistentu",
        "SUCCESS_MESSAGE": "Asistents ir veiksmīgi atjaunināts",
        "ERROR_MESSAGE": "Atjauninot asistentu radās kļūda. Lūdzu, mēģiniet vēlreiz.",
        "NOT_FOUND": "Could not find the assistant. Please try again."
      },
      "SETTINGS": {
        "HEADER": "Iestatījumi",
        "BASIC_SETTINGS": {
          "TITLE": "Basic settings",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "SYSTEM_SETTINGS": {
          "TITLE": "System settings",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "CONTROL_ITEMS": {
          "TITLE": "The Fun Stuff",
          "DESCRIPTION": "Add more control to the assistant. (a bit more visual like a story : Query guardrail → scenarios → output) Nudges user to actually utilise these.",
          "OPTIONS": {
            "GUARDRAILS": {
              "TITLE": "Guardrails",
              "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic."
            },
            "RESPONSE_GUIDELINES": {
              "TITLE": "Response guidelines",
              "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?"
            }
          }
        },
        "DELETE": {
          "TITLE": "Dzēst Asistentu",
          "DESCRIPTION": "Šī darbība ir pastāvīga. Dzēšot šo asistentu, tas tiks noņemts no visām pievienotajām iesūtnēm un neatgriezeniski dzēstas visas ģenerētās zināšanas.",
          "BUTTON_TEXT": "Dzēst {assistantName}"
        }
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Rediģēt Asistentu",
        "DELETE_ASSISTANT": "Dzēst Asistentu",
        "VIEW_CONNECTED_INBOXES": "Skatīt pievienotās iesūtnes"
      },
      "EMPTY_STATE": {
        "TITLE": "Asistenti nav pieejami",
        "SUBTITLE": "Izveidot palīgu, lai sniegtu lietotājiem ātras un precīzas atbildes. Tas var mācīties no Jūsu palīdzības rakstiem un iepriekšējām sarunām.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      },
      "GUARDRAILS": {
        "TITLE": "Guardrails",
        "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic.",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Dzēst"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example guardrails",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another guardrail..."
          },
          "NEW": {
            "TITLE": "Add a guardrail",
            "CREATE": "Izveidot",
            "CANCEL": "Atcelt",
            "PLACEHOLDER": "Type in another guardrail...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Meklēt..."
        },
        "EMPTY_MESSAGE": "No guardrails found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No guardrails found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Guardrails added successfully",
            "ERROR": "There was an error adding guardrails, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Guardrails updated successfully",
            "ERROR": "There was an error updating guardrails, please try again."
          },
          "DELETE": {
            "SUCCESS": "Guardrails deleted successfully",
            "ERROR": "There was an error deleting guardrails, please try again."
          }
        }
      },
      "RESPONSE_GUIDELINES": {
        "TITLE": "Response Guidelines",
        "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Dzēst"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example response guidelines",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another response guideline..."
          },
          "NEW": {
            "TITLE": "Add a response guideline",
            "CREATE": "Izveidot",
            "CANCEL": "Atcelt",
            "PLACEHOLDER": "Type in another response guideline...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Meklēt..."
        },
        "EMPTY_MESSAGE": "No response guidelines found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No response guidelines found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Response Guidelines added successfully",
            "ERROR": "There was an error adding response guidelines, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Response Guidelines updated successfully",
            "ERROR": "There was an error updating response guidelines, please try again."
          },
          "DELETE": {
            "SUCCESS": "Response Guidelines deleted successfully",
            "ERROR": "There was an error deleting response guidelines, please try again."
          }
        }
      },
      "SCENARIOS": {
        "TITLE": "Scenarios",
        "DESCRIPTION": "Give your assistant some context—like “what to do when a user is stuck,” or “how to act during a refund request.”",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Dzēst"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example scenarios",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "TOOLS_USED": "Tools used :"
          },
          "NEW": {
            "CREATE": "Add a scenario",
            "TITLE": "Create a scenario",
            "FORM": {
              "TITLE": {
                "LABEL": "Nosaukums",
                "PLACEHOLDER": "Enter a name for the scenario",
                "ERROR": "Scenario name is required"
              },
              "DESCRIPTION": {
                "LABEL": "Apraksts",
                "PLACEHOLDER": "Describe how and where this scenario will be used",
                "ERROR": "Scenario description is required"
              },
              "INSTRUCTION": {
                "LABEL": "How to handle",
                "PLACEHOLDER": "Describe how and where this scenario will be handled",
                "ERROR": "Scenario content is required"
              },
              "CREATE": "Izveidot",
              "CANCEL": "Atcelt"
            }
          }
        },
        "UPDATE": {
          "CANCEL": "Atcelt",
          "UPDATE": "Update changes"
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Meklēt..."
        },
        "EMPTY_MESSAGE": "No scenarios found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No scenarios found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Scenarios added successfully",
            "ERROR": "There was an error adding scenarios, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Scenarios updated successfully",
            "ERROR": "There was an error updating scenarios, please try again."
          },
          "DELETE": {
            "SUCCESS": "Scenarios deleted successfully",
            "ERROR": "There was an error deleting scenarios, please try again."
          }
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Dokumenti",
      "ADD_NEW": "Izveidot jaunu dokumentu",
      "SELECTED": "Atlasīti {count}",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "BULK_DELETE_BUTTON": "Dzēst",
      "BULK_SYNC_BUTTON": "Atjaunot",
      "BULK_DELETE": {
        "TITLE": "Delete documents?",
        "DESCRIPTION": "Are you sure you want to delete the selected documents? This action cannot be undone.",
        "CONFIRM": "Jā, dzēst visu",
        "SUCCESS_MESSAGE": "Documents deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the documents, please try again."
      },
      "BULK_SYNC": {
        "SUCCESS_MESSAGE_ONE": "Refresh queued for 1 document",
        "SUCCESS_MESSAGE": "Refresh queued for {count} documents",
        "ZERO_MESSAGE": "No documents marked for refresh.",
        "ERROR_MESSAGE": "There was an error queuing the refresh, please try again."
      },
      "SYNC": {
        "QUEUED_MESSAGE": "Refresh queued. We'll update the document shortly.",
        "ERROR_MESSAGE": "Could not queue refresh, please try again."
      },
      "FILTERS": {
        "SOURCE": {
          "ALL": "All sources",
          "WEB": "Web pages",
          "PDF": "PDFs"
        },
        "STATUS": {
          "ANY": "Any status",
          "UPDATED": "Updated",
          "NEEDS_UPDATE": "Needs update",
          "UPDATING": "Updating",
          "FAILED": "Failed"
        },
        "SORT": {
          "RECENTLY_UPDATED": "Recently updated",
          "RECENTLY_CREATED": "Recently created"
        },
        "SEARCH_PLACEHOLDER": "Meklēt..."
      },
      "SYNC_STATUS": {
        "SYNCED": "last updated {time}",
        "SYNCING": "updating...",
        "STALE_SYNC": "update stalled",
        "FAILED": "Failed to sync",
        "NEVER_SYNCED": "not updated yet"
      },
      "SYNC_ERRORS": {
        "NOT_FOUND": "Lapa nav atrasta",
        "ACCESS_DENIED": "Access denied",
        "TIMEOUT": "Page took too long to respond",
        "CONTENT_EMPTY": "Page returned empty content",
        "FETCH_FAILED": "Could not fetch page",
        "SYNC_ERROR": "Unexpected error",
        "DEFAULT": "Sync error"
      },
      "RELATED_RESPONSES": {
        "TITLE": "Saistītie bieži uzdotie jautājumi",
        "DESCRIPTION": "Šie bieži uzdotie jautājumi tiek ģenerēti tieši no dokumenta."
      },
      "FORM_DESCRIPTION": "Ievadiet dokumenta URL, lai to pievienotu kā zināšanu avotu, un izvēlieties asistentu, ar kuru to saistīt.",
      "CREATE": {
        "TITLE": "Pievienot dokumentu",
        "SUCCESS_MESSAGE": "Dokuments ir veiksmīgi izveidots",
        "ERROR_MESSAGE": "Veidojot dokumentu, radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM": {
        "TYPE": {
          "LABEL": "Document Type",
          "URL": "URL",
          "PDF": "PDF File"
        },
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Ievadiet dokumenta URL",
          "ERROR": "Lūdzu, norādiet pareizu dokumenta URL"
        },
        "PDF_FILE": {
          "LABEL": "PDF File",
          "CHOOSE_FILE": "Choose PDF file",
          "ERROR": "Please select a PDF file",
          "HELP_TEXT": "Maximum file size: 10MB",
          "INVALID_TYPE": "Please select a valid PDF file",
          "TOO_LARGE": "File size exceeds 10MB limit"
        },
        "NAME": {
          "LABEL": "Document Name (Optional)",
          "PLACEHOLDER": "Enter a name for the document"
        }
      },
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties izdzēst šo dokumentu?",
        "DESCRIPTION": "Šī darbība ir pastāvīga. Dzēšot šo dokumentu visas ģenerētās zināšanas tiks neatgriezeniski izdzēstas.",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Dokuments ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Dzēšot dokumentu radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "Skatīt Saistītās Atbildes",
        "SYNC_NOW": "Refresh now",
        "RETRY_SYNC": "Retry refresh",
        "DELETE_DOCUMENT": "Dzēst Dokumentu"
      },
      "EMPTY_STATE": {
        "TITLE": "Dokumenti nav pieejami",
        "SUBTITLE": "Jūsu palīgs izmanto dokumentus, lai izveidotu bieži uzdotos jautājumus. Jūs varat importēt dokumentus, lai nodrošinātu kontekstu savam palīgam.",
        "FILTERED_TITLE": "No matching documents",
        "FILTERED_SUBTITLE": "Try changing the source, status, or search term.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "CUSTOM_TOOLS": {
      "HEADER": "Tools",
      "ADD_NEW": "Create a new tool",
      "SOFT_LIMIT_WARNING": "Having more than 10 tools may reduce the assistant's reliability in selecting the right tool. Consider removing unused tools for better results.",
      "EMPTY_STATE": {
        "TITLE": "No custom tools available",
        "SUBTITLE": "Create custom tools to connect your assistant with external APIs and services, enabling it to fetch data and perform actions on your behalf.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Custom Tools",
          "NOTE": "Custom tools allow your assistant to interact with external APIs and services. Create tools to fetch data, perform actions, or integrate with your existing systems to enhance your assistant's capabilities."
        }
      },
      "FORM_DESCRIPTION": "Configure your custom tool to connect with external APIs",
      "OPTIONS": {
        "EDIT_TOOL": "Edit tool",
        "DELETE_TOOL": "Delete tool"
      },
      "CREATE": {
        "TITLE": "Create Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool created successfully",
        "ERROR_MESSAGE": "Failed to create custom tool"
      },
      "EDIT": {
        "TITLE": "Edit Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool updated successfully",
        "ERROR_MESSAGE": "Failed to update custom tool"
      },
      "DELETE": {
        "TITLE": "Delete Custom Tool",
        "DESCRIPTION": "Are you sure you want to delete this custom tool? This action cannot be undone.",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Custom tool deleted successfully",
        "ERROR_MESSAGE": "Failed to delete custom tool"
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use tools with Captain",
        "AVAILABLE_ON": "Captain Tools are only available in Business and Enterprise plans. Please upgrade to Business plan to use the feature.",
        "UPGRADE_PROMPT": "",
        "UPGRADE_NOW": "Atvērt norēķinus",
        "CANCEL_ANYTIME": ""
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Captain Tools are only available in the paid plans.",
        "UPGRADE_PROMPT": "Please upgrade to a paid plan to use this feature.",
        "ASK_ADMIN": "Lai pārietu uz maksas versiju, lūdzu sazinieties ar savu administratoru."
      },
      "TEST": {
        "BUTTON": "Test connection",
        "SUCCESS": "Endpoint returned HTTP {status}",
        "ERROR": "Connection failed",
        "DISABLED_HINT": "Testing is only available for endpoints without templates or request bodies."
      },
      "FORM": {
        "TITLE": {
          "LABEL": "Tool Name",
          "PLACEHOLDER": "Order Lookup",
          "ERROR": "Tool name is required",
          "MAX_LENGTH_ERROR": "Tool name must be {max} characters or fewer"
        },
        "DESCRIPTION": {
          "LABEL": "Apraksts",
          "PLACEHOLDER": "Looks up order details by order ID"
        },
        "HTTP_METHOD": {
          "LABEL": "Method"
        },
        "ENDPOINT_URL": {
          "LABEL": "Endpoint URL",
          "PLACEHOLDER": "https://api.example.com/orders/{'{{'} order_id {'}}'}",
          "ERROR": "Valid URL is required"
        },
        "AUTH_TYPE": {
          "LABEL": "Authentication Type"
        },
        "AUTH_TYPES": {
          "NONE": "Nav",
          "BEARER": "Bearer Token",
          "BASIC": "Basic Auth",
          "API_KEY": "API atslēga"
        },
        "AUTH_CONFIG": {
          "BEARER_TOKEN": "Bearer Token",
          "BEARER_TOKEN_PLACEHOLDER": "Enter your bearer token",
          "USERNAME": "Username",
          "USERNAME_PLACEHOLDER": "Enter username",
          "PASSWORD": "Parole",
          "PASSWORD_PLACEHOLDER": "Enter password",
          "API_KEY": "Header Name",
          "API_KEY_PLACEHOLDER": "X-API-Key",
          "API_VALUE": "Header Value",
          "API_VALUE_PLACEHOLDER": "Enter API key value"
        },
        "PARAMETERS": {
          "LABEL": "Parameters",
          "HELP_TEXT": "Define the parameters that will be extracted from user queries"
        },
        "ADD_PARAMETER": "Add Parameter",
        "PARAM_NAME": {
          "PLACEHOLDER": "Parameter name (e.g., order_id)"
        },
        "PARAM_TYPE": {
          "PLACEHOLDER": "Tips"
        },
        "PARAM_TYPES": {
          "STRING": "String",
          "NUMBER": "Numurs",
          "BOOLEAN": "Boolean",
          "ARRAY": "Array",
          "OBJECT": "Object"
        },
        "PARAM_DESCRIPTION": {
          "PLACEHOLDER": "Description of the parameter"
        },
        "PARAM_REQUIRED": {
          "LABEL": "Nepieciešams"
        },
        "REQUEST_TEMPLATE": {
          "LABEL": "Request Body Template (Optional)",
          "PLACEHOLDER": "{'{'}\n  \"order_id\": \"{'{{'} order_id {'}}'}\"\n{'}'}"
        },
        "RESPONSE_TEMPLATE": {
          "LABEL": "Response Template (Optional)",
          "PLACEHOLDER": "Order {'{{'} order_id {'}}'} status: {'{{'} status {'}}'}"
        },
        "ERRORS": {
          "PARAM_NAME_REQUIRED": "Parameter name is required"
        }
      }
    },
    "RESPONSES": {
      "HEADER": "Bieži uzdotie jautājumi",
      "PENDING_FAQS": "Pending FAQs",
      "ADD_NEW": "Izveidot jaunu sarakstu ar bieži uzdotiem jautājumiem",
      "DOCUMENTABLE": {
        "CONVERSATION": "Saruna #{id}"
      },
      "SELECTED": "Atlasīti {count}",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "SEARCH_PLACEHOLDER": "Search FAQs...",
      "BULK_APPROVE_BUTTON": "Apstiprināt",
      "BULK_DELETE_BUTTON": "Dzēst",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "Bieži uzdotie jautājumi ir veiksmīgi apstiprināti",
        "ERROR_MESSAGE": "Apstiprinot bieži uzdotos jautājumus radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "BULK_DELETE": {
        "TITLE": "Vai dzēst bieži uzdotos jautājumus?",
        "DESCRIPTION": "Vai tiešām vēlaties dzēst atlasītos bieži uzdotos jautājumus? Šo darbību nevar atsaukt.",
        "CONFIRM": "Jā, dzēst visu",
        "SUCCESS_MESSAGE": "Bieži uzdotie jautājumi ir veiksmīgi izdzēsti",
        "ERROR_MESSAGE": "Dzēšot bieži uzdotos jautājumus radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties izdzēst šos bieži uzdotos jautājumus?",
        "DESCRIPTION": "",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Bieži uzdotie jautājumi ir veiksmīgi izdzēsti",
        "ERROR_MESSAGE": "Dzēšot bieži uzdotos jautājumus radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FILTER": {
        "ASSISTANT": "Asistents: {selected}",
        "STATUS": "Statuss: {selected}",
        "ALL_ASSISTANTS": "Visi"
      },
      "STATUS": {
        "TITLE": "Statuss",
        "PENDING": "Gaida",
        "APPROVED": "Apstiprināts",
        "ALL": "Visi"
      },
      "PENDING_BANNER": {
        "TITLE": "Captain has found some FAQs your customers were looking for.",
        "ACTION": "Click here to review"
      },
      "FORM_DESCRIPTION": "Pievienot jautājumu un tā atbildi zināšanu bāzei, kā arī izvēlēties asistentu, ar kuru tas būs saistīts.",
      "CREATE": {
        "TITLE": "Pievienot bieži uzdotos jautājumus",
        "SUCCESS_MESSAGE": "Atbilde ir veiksmīgi pievienota.",
        "ERROR_MESSAGE": "Pievienojot atbildi radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Jautājums",
          "PLACEHOLDER": "Ievadiet jautājumu šeit",
          "ERROR": "Lūdzu, ievadiet derīgu jautājumu."
        },
        "ANSWER": {
          "LABEL": "Atbilde",
          "PLACEHOLDER": "Ievadiet atbildi šeit",
          "ERROR": "Lūdzu, ievadiet derīgu atbildi."
        }
      },
      "EDIT": {
        "TITLE": "Atjaunināt bieži uzdotos jautājumus",
        "SUCCESS_MESSAGE": "Bieži uzdotie jautājumi ir veiksmīgi atjaunināti",
        "ERROR_MESSAGE": "Atjauninot bieži uzdotos jautājumus, radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "APPROVE_SUCCESS_MESSAGE": "Bieži uzdotie jautājumi tika atzīmēti kā apstiprināti"
      },
      "OPTIONS": {
        "APPROVE": "Apstiprināt",
        "EDIT_RESPONSE": "Rediģēt",
        "DELETE_RESPONSE": "Dzēst"
      },
      "EMPTY_STATE": {
        "TITLE": "Bieži uzdoto jautājumu saraksti nav atrasti",
        "NO_PENDING_TITLE": "There are no more pending FAQs to review",
        "SUBTITLE": "Bieži uzdotie jautājumi palīdz Jūsu asistentam sniegt ātras un precīzas atbildes uz Jūsu klientu jautājumiem. Tos var ģenerēt automātiski no jūsu satura vai pievienot manuāli.",
        "CLEAR_SEARCH": "Clear active filters",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Pievienotās Iesūtnes",
      "ADD_NEW": "Pievienot jaunu iesūtni",
      "OPTIONS": {
        "DISCONNECT": "Atvienot"
      },
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties atvienot iesūtni?",
        "DESCRIPTION": "",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Iesūtne tika veiksmīgi atvienota.",
        "ERROR_MESSAGE": "Atvienojot iesūtni radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM_DESCRIPTION": "Izvēlieties iesūtni, lai izveidotu savienojumu ar asistentu.",
      "CREATE": {
        "TITLE": "Pievienot Iesūtni",
        "SUCCESS_MESSAGE": "Iesūtne tika veiksmīgi pievienota.",
        "ERROR_MESSAGE": "Pievienojot iesūtni radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Iesūtne",
          "PLACEHOLDER": "Izvēlieties iesūtni, lai aktivētu asistentu.",
          "ERROR": "Nepieciešams izvēlēties iesūtni."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nav Pievienotu Iesūtņu",
        "SUBTITLE": "Iesūtnes pievienošana ļauj asistentam apstrādāt Jūsu klientu sākotnējos jautājumus, pirms tos pārsūtīt Jums."
      }
    }
  }
}
